<script>
  import options from './SearchHeader.options'
  export default options
</script>

<template>
  <article class="nlx-search-header">
    
    <div class="nlx-site-navigation__search-menu__searchfield">
        <div class="nlx-site-navigation__search-menu__icon-container"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-search" viewBox="0 0 24 24" stroke-width="1.5" stroke="#2c3e50" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"></path><circle cx="10" cy="10" r="7"></circle><line x1="21" y1="21" x2="15" y2="15"></line></svg></div>
        <input class="nlx-site-navigation__search-menu__inputfield" v-model="searchString">
        <button @click="clearSearch" class="nlx-site-navigation__search-menu__clear-search">{{getLabel('clear_search')}}</button>
    </div>
    
  </article>
</template>
